import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6 21a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3zm12 -16h-8v14h8a1 1 0 0 0 1 -1v-12a1 1 0 0 0 -1 -1","key":"svg-0"}]]

const IconLayoutSidebarFilled = createReactComponent('filled', 'layout-sidebar-filled', 'LayoutSidebarFilled', __iconNode);

export default IconLayoutSidebarFilled;